const ITEMS = [
  "Plus de 20 ans d'expérience",
  "Sans rendez-vous",
  "Devis gratuit",
  "Pneus neufs et occasions",
];

export default function Marquee() {
  const ligne = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="bg-brand-dark py-5 overflow-hidden" aria-label="Nos engagements">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((moitie) => (
          <div key={moitie} className="flex" aria-hidden={moitie === 1}>
            {ligne.map((item, i) => (
              <span
                key={`${moitie}-${i}`}
                className="font-heading font-semibold uppercase tracking-[0.2em] text-white text-lg sm:text-xl px-8 flex items-center gap-8"
              >
                {item}
                <span className="text-brand-red" aria-hidden="true">{"//"}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
